import StateManager from "../scuba/StateManager";
import LayoutManager from "../scuba/LayoutManager";
var Flickity = require("flickity");

/* -------------------------
    INIT
------------------------- */

$(window).on(StateManager.CONTENT_READY, function(event, node) {
  $(node)
    .find(".carousel")
    .each(function(i, el) {
      new Carousel(el);
    });
});

function Carousel(el) {
  var self = this;
  self.el = el;
  self.$el = $(el);
  // Moche mais nécessaire après un coup d'ajax
  setTimeout(function() {
    self.init();
  }, 400);
}

Carousel.prototype.getItemsWidth = function() {
  var $size = $(window).width();
  var $nb_items = 0;
  if ($size < 640) {
    $nb_items = 1;
  } else {
    $nb_items = 2;
  }
  return $nb_items;
};

Carousel.prototype.init = function() {
  var self = this;
  // var $gallery = $('.gallery')

  $(window)
    .on("resize", function() {
      var $new_width = self.getItemsWidth();
      if ($new_width !== self.itemsWidth) {
        self.itemsWidth = $new_width;
        if (self.flickity) {
          self.flickity.destroy();
        }
        self.flickity = new Flickity(self.el, {
          // imagesLoaded: true,
          pageDots: false,
          groupCells: 1,
          cellAlign: "left",
          contain: true
          //   setGallerySize: false,
        });

        // self.flickity = new Flickity(self.el, {
        //     // imagesLoaded: true,
        //   pageDots: false,
        //   groupCells: 4,
        //   cellAlign: 'left',
        //   contain: true,
        // //   setGallerySize: false,
        // })
      }
    })
    .trigger("resize");

  //   if (self.$el.hasClass('lightboxes')) {
  //     self.$lightboxes = this.$el.find('.lightbox')

  //     self.$lightboxes.on('click', function(e) {
  //       e.preventDefault()
  //     })

  //     self.flickity.on('staticClick', function(
  //       event,
  //       pointer,
  //       cellElement,
  //       cellIndex
  //     ) {
  //       if (!cellElement) {
  //         return
  //       }
  //       if (typeof self.modal === 'undefined') {
  //         self.modal = self.$el.data('modal')
  //       }
  //       self.modal.open(cellIndex)
  //     })
  //   }
};



// WEBPACK FOOTER //
// ./scripts/components/Carousel.js